import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import Loader from '../../components/loader/loader';
import { newsroomSidebar } from './newsroom-sidebar';
import { TranslationProvider } from '@context/translation-context';

const NewsroomNavigation = lazy(
  () =>
    import(
      /* webpackChunkName: "newsroom" */ './newsroom-navigation/newsroom-navigation'
    )
);

const Newsroom = lazy(
  () => import(/* webpackChunkName: "newsroom" */ './newsroom')
);

/**
 * Build Newsroom.
 */
export const newsroom = () => {
  const newsroom: NodeListOf<HTMLElement> =
    document.querySelectorAll('.newsroom');
  const newsroomNav = document.getElementById('newsroom-nav');
  if (newsroomNav) {
    const root = createRoot(newsroomNav);
    root.render(
      <Suspense fallback={<Loader />}>
        <TranslationProvider>
          <NewsroomNavigation />
        </TranslationProvider>
      </Suspense>
    );
  }
  if (newsroom) {
    newsroomSidebar();
    newsroom.forEach((newsroomType, index: number) => {
      const { category } = newsroomType.dataset;
      const safeCategory = category ? category : '';
      const root = createRoot(newsroom[index]);
      root.render(
        <Suspense fallback={<Loader />}>
          <TranslationProvider>
            <Newsroom category={safeCategory} index={index} key={category} />
          </TranslationProvider>
        </Suspense>
      );
    });
  }
};
